import { useState } from "react";
import DataTable from "../components/DataTable";
import Page from "../components/Page";
import TableActions from "../components/TableActions";
import { useHistory } from 'react-router-dom';

import { useUserProvider } from "../providers/UserProvider";
import { useModalProvider } from "../providers/ModalProvider";
import { GetAppResource } from "../services/api/app";

import DeleteItem from "../components/modal_contents/DeleteItem";
import { DeleteCustomCTA } from "../services/api/custom_cta";
import { contentList } from "../components/modal_contents/PushNotificationModal/contentList";
import { CloneItem } from "../services/api/clone";
import { IsLowerVersion } from "../lib/useVersionizer";

const CustomCTAList = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [data, setData] = useState({
    loading: false,
    data: [],
    count: 0,
  });

  const shouldHideCta = IsLowerVersion('10.0')

  console.log({shouldHideCta})

  const history = useHistory();
  const { user } = useUserProvider();
  const { showModal, closeModal } = useModalProvider();

  const loadData = async () => {
    setData({ ...data, loading: true });
    GetAppResource(user, 'call_to_actions')
      .then(res => res.json())
      .then(jsonData => {
        setData({
          loading: false,
          data: jsonData.data,
          count: jsonData.data.length,
        });
      });
  };

  const deleteButtonHandler = async (id) => {
    await DeleteCustomCTA(user.idToken, id);
    loadData();
    closeModal();
  }


  const metadata = [
    {
      name: 'name',
      label: 'Name',
      parser: (data) => (data.name),
    },
    ...(!shouldHideCta ? [
      {
        name: 'cta_type',
        label: 'CTA Type',
        parser: (data) => data.cta_type,
      },
    ] : []),
    {
      name: 'text',
      label: 'Call to Action Text',
      parser: (data) => (data.text),
    },
    {
      name: 'url',
      label: 'Call to Action URL',
      parser: (data) => <div className="text-ellipsis" style={{
        maxWidth: '300px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      }}>
        {(data.cta_type === 'URL CTA' ? data.url : 'N/A')}
      </div>,
    },
    ...(!shouldHideCta ? [
      {
        name: 'content_type',
        label: 'Content Type',
        parser: (data) => (data.cta_type === 'Content CTA' ? data?.content?.type === 'flex' ? "Flex Content": 
          contentList.find(item => item.value === data.content?.type)?.name : 'N/A'),
      },
    ] : []),
  
    {
      name: "update",
      label: "Actions",
      parser: (data) => (
       <TableActions
        onUpdateClick={() => updateButtonHandler(data.id)}
        onDeleteClick={() => showDeleteModal(data.id)}
        item_id={data.id}
        onCloneClick={async () => {
          const res = await CloneItem(user, {
            data: {
              id: data.id,
              name: 'call_to_actions',
            }
          })

          const cloneData = await res.json();
          const cloneId = cloneData.data?.id;

          window.location = `/custom_cta/${cloneId}`;
        }}
        onlyUpdateAllowed={data.name?.toLowerCase?.() === "register now"}
       />
      ),
    },
  ];

  
  const showDeleteModal = (id) => {
    showModal(
      <DeleteItem
        itemId={id}
        itemLabel={
          'Preset CTA'
        }
        onDelete={deleteButtonHandler}
        onClose={closeModal}
      />
    );
  };


  const AddButton = () => {
    return <button className="ttnk-button add-button" onClick={() => history.push('/custom_cta/new')}>Add Preset CTA</button>
  }


  const updateButtonHandler = async (id) => {
    history.push(`/custom_cta/${id}`);
  }


  const links = [
    { name: "Home", url: "/" },
    { name: "Preset CTA", url: "/custom_cta" },
  ];

  return (
    <Page links={links} title="PRESET CTA" titleComponent={AddButton()}>
      <DataTable
        metadata={metadata}
        dataLoader={loadData}
        data={data}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        searchKeys={['name', 'cta_text']}
      />
    </Page>
  );
}

export default CustomCTAList;
